export const COOKIEBOT_CBID = process.env.NEXT_PUBLIC_COOKIEBOT_CBID || '';
